<template>
  <div>
    <v-row>
      <v-col>
        <v-text-field
            v-model="postal_code"
            color="primary"
            append-outer-icon="mdi-send"
            filled
            clear-icon="mdi-close-circle"
            clearable
            :label="$t('Introduce tu código postal')"
            type="number"
            @click:append-outer="get_coordinates"
            @keypress.enter="get_coordinates"
            hide-spin-buttons
        ></v-text-field>
      </v-col>
    </v-row>

    <div v-if="centros.length">
      <v-layout row>
        <v-flex>
          <h1 class="text-center">{{$t('Selecciona tu centro')}}</h1>
        </v-flex>
      </v-layout>
      <v-layout class="mt-5" v-for="current_centro in centros" :key="current_centro.id">
        <v-flex class="pointer" xs12 sm6 offset-sm3 @click="go_to_centro(current_centro)">
          <v-card>
            <v-img class="imagen_centro"
                   :src="current_centro.imagenes_absolute_path[0].name"
                   aspect-ratio="2.75"
            ></v-img>
            <v-card-title primary-title class="d-flex justify-space-between">
              <div>
                <h3 class="headline">{{ current_centro.nombre }}</h3>
              </div>
              <div v-if="idsCentrosAvailabilityHigh.has(current_centro.id)">
                <v-chip
                    color="green lighten-1"
                    label
                >
                  <v-avatar left>
                    <v-icon>mdi-checkbox-marked-circle</v-icon>
                  </v-avatar>
                  <span class="font-weight-bold">{{ $t('Disponibilidad alta') }}</span>
                </v-chip>
              </div>
            <div class="pt-1">
              <h4>{{current_centro.direccion}}</h4>
            </div>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import show_toolbar_mixin from "@/mixins/show_toolbar_mixin";
import {locale} from "@/plugins/vue-i18n";

export default {
  name: 'Centros',
  mixins: [show_toolbar_mixin],
  data() {
    return {
      centros: [],
      lat: null,
      lng: null,
      postal_code: null,
      idsCentrosAvailabilityHigh: new Set([1954, 1997, 2000])
    }
  },

  methods: {

    locale() {
      return locale
    },

    /**
     * Obtiene el código postal a través de la geolocalización
     */
    get_postal_code() {
      this.$store.commit('set_loading', true)

      navigator.geolocation.getCurrentPosition(
          async position => {
            this.lat = position.coords.latitude
            this.lng = position.coords.longitude

            this.postal_code = await this.$store.dispatch('common/get_postal_code', {
              lat: this.lat,
              lng: this.lng
            })
            await this.get_centros()

          },
          error => {
            this.$store.commit('set_loading', false)
          }
      )
    },

    /**
     * Obtiene las coordenadas a través de un código postal
     * @returns {Promise<void>}
     */
    async get_coordinates() {
      const coords = await this.$store.dispatch('common/get_coordinates_from_postal_code', {
        postal_code: this.postal_code,
        locale: this.locale()
      })
      if (coords) {
        this.lat = coords.lat
        this.lng = coords.lng
      }
      await this.get_centros()
    },

    /**
     * Recupera todos los centros de la api
     * @returns {Promise<void>}
     */
    async get_centros () {
      const { results } = await this.$store.dispatch('centro/get_centros', {
        latitude: this.lat,
        longitude: this.lng,
        limit: 5
      })
      this.centros = results

    },

    async go_to_centro (centro) {
      const { utm_source, utm_medium, utm_campaign } = this.get_utm_params()

      this.$store.commit('centro/set_centro', centro)
      this.$store.commit('reserva/set_centro', this.$store.state.centro.centro.id)

      if (utm_source && utm_medium && utm_campaign) {
        await this.$router.push(
            { name: 'centro', params: { slug: centro.slug }, query: { utm_source, utm_medium, utm_campaign } })
      } else {
        await this.$router.push({ name: 'centro', params: { slug: centro.slug } })
      }
    },

    get_utm_params () {
      const utm_source = this.$route.query.utm_source
      const utm_medium = this.$route.query.utm_medium
      const utm_campaign = this.$route.query.utm_campaign
      return { utm_source, utm_medium, utm_campaign }
    }
  },

  mounted() {
    this.$store.commit('common/set_show_toolbar', false)
    this.get_postal_code()
  }
}
</script>

<style lang="less" scoped>
.imagen_centro {
  min-height: 270px;
}
</style>
